import errorMessages from '@common/constants/errorMessages';

export const isDueDateValid = (value) => {
  if (Number(value) >= 1 && Number(value) <= 31) {
    return errorMessages.CLEAR_ERROR;
  }

  return errorMessages.ONBOARDING_V2_DUE_DATE_REQUIRED;
};

// Keeping this specific to the Dashboard and Setup New Term flow for now, since both are still using class component
export const validateAllInputs = (ctx) => {
  const { paymentDayOfTheMonth } = ctx.state;
  const errors: Array<Record<string, string>> = [];
  const dueDateError = isDueDateValid(paymentDayOfTheMonth);
  if (dueDateError) {
    errors.push({ dueDateError });
  }

  ctx.setState({
    error: dueDateError,
  });

  if (errors.length > 0) {
    ctx.props.trackValidationError({ errors });
    return false;
  }
  return true;
};
